import React ,{ useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import MainPage from './pages/MainPage';
import ExclusivePage from './pages/ExclusivePage';
import LatestPage from './pages/LatestPage';
import AgentsPage from './pages/AgentsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import PropertyDetailsPage from './pages/PropertyDetailsPage';
import DeveloperDetailsPage from './pages/DeveloperDetailsPage';
import CommunityDetailsPage from './pages/CommunityDetailsPage';
import BaseLayout from './components/Layout/BaseLayout';
import { GlobalProvider } from "./GlobalContext";
import BlogPage from './pages/BlogPage'
import BlogDetailPage from './pages/BlogDetailPage'
import ThankYouPage from './pages/ThankYouPage';
import WhatsAppWidget from './components/WhatsappWidget';
import SalesOfferTemplate from './components/SalesOfferTemplate';
import LeadsPanel from './pages/LeadsPanel';
import PropertyTypePage from './pages/PropertyTypePage';
import UaeDevelopersPage from './pages/UaeDevelopersPage';
import LearnMore from './pages/LearnMore';
import PrivacyPolicy from './pages/PrivacyPage'
import TermsOfUse from './pages/TermsPage'
import FAQ from './pages/FAQ'
import LoginPage from './pages/Login/LoginPage';
import PublicRoute from './components/Routes/PublicRoute';
import RegisterPage from './pages/Register/RegisterPage';
import PrivateRoute from './components/Routes/PrivateRoute';
import ProfilePage from './pages/Profile/ProfilePage';
import './i18n';

import NotFoundPage from './pages/NotFoundPage';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Helmet } from 'react-helmet';



function App() {
    const { i18n } = useTranslation();

    useEffect(() => {
        document.documentElement.lang = i18n.language;

        document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
    }, [i18n.language]);

    return (
        <>
            <Helmet>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
                <link
                    href="https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap"
                    rel="stylesheet"
                />
            </Helmet>
            <GlobalProvider>
            <ToastContainer position="top-right" autoClose={2000} />
                <Routes>
                    {/* Auth routes without BaseLayout */}
                    <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
                    <Route path="/register" element={<PublicRoute><RegisterPage /></PublicRoute>} />
                     <Route path="*" element={<NotFoundPage />} />
                    {/* <Route path="/admin/login" element={<PublicRoute><AdminLoginPage /></PublicRoute>} />  */}


                    {/* Base Layout for authenticated pages */}
                    <Route element={<BaseLayout />}>
                        <Route path="/" element={<MainPage />} />
                        <Route path="/exclusive" element={<ExclusivePage />} />
                        <Route path="/latest" element={<LatestPage />} />
                        <Route path="/agents" element={<AgentsPage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/property-detail/:idOrSlug" element={<PropertyDetailsPage />} />
                        <Route path="/developer-detail/:idOrSlug" element={<DeveloperDetailsPage />} />
                        <Route path="/community-detail/:idOrSlug" element={<CommunityDetailsPage />} />
                        <Route path="/blog" element={<BlogPage />} />
                        <Route path="/blog/:slug" element={<BlogDetailPage />} />
                        <Route path="/thank-you" element={<ThankYouPage />} />
                        <Route path="/sales-offer" element={<SalesOfferTemplate />} />
                        <Route path="/leads-panel" element={<LeadsPanel />} />
                        <Route path="/uae-developers" element={<UaeDevelopersPage />} />
                        <Route path="/properties/type/:propertyType" element={<PropertyTypePage />} />
                        <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />


                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/terms-of-use" element={<TermsOfUse />} />


                        <Route path="/learn-more" element={<LearnMore />} />
                        <Route path="/faq" element={<FAQ />} />
                       
                    </Route>


                </Routes>
                <WhatsAppWidget
                    defaultPhoneNumber="971552554245"
                    companyName="JustOffPlan AI"
                    agentName="JustOffPlan Support"
                    message="Hello, I'd like to inquire about off-plan properties in Dubai."
                />

            </GlobalProvider>





        </>
    );
}

export default App;
